import { createContext, useContext, useEffect, useState } from 'react';
import api from '../lib/api';

const SiteCtx = createContext(null);
export const useSite = () => useContext(SiteCtx);

export function SiteProvider({ children }) {
  const [site, setSite] = useState({});
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [payByBankStatus, setPayByBankStatus] = useState('awaiting_approval');
  const [loaded, setLoaded] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get('/settings/public');
      setSite(data.site || {});
      setPaymentMethods(data.payment_methods || []);
      setPayByBankStatus(data.pay_by_bank_status || 'awaiting_approval');
    } catch {} finally {
      setLoaded(true);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <SiteCtx.Provider value={{ site, paymentMethods, payByBankStatus, loaded, reload: load }}>
      {children}
    </SiteCtx.Provider>
  );
}
